import React from 'react'
import {observer} from 'mobx-react-lite'
import {Box, Flex, Stack, Text, BaseButton} from '../../../vanilla'
import {useBasketStore, useGlobalStore, useRapidDeliveryStore} from '../../../store/hooks/useStore'
import {Link} from '../../../components/link'
import {DeliveryAddress} from '../../../components/book-delivery/delivery-address'
import {DeliveryDateTime} from '../../../components/book-delivery/delivery-date-time'
import DeliveryInitial from './delivery-initial'
import NearestStoreDetails from '../../../components/nearest-store-details'
import {Wrapper} from '@googlemaps/react-wrapper'
import useNavigation from '../../../hooks/use-navigation'
import {useSlotExpiration} from '../../../store/hooks/useSlotExpiration'
import DeliveryRestrictionNotice from '../../../components/delivery-restriction-notice'
import { RapidLabelIcon } from '../../../components/icons'

const DeliveryActionContainer = () => {
  const navigate = useNavigation()
  const {deliveryPostalCode, isAppliedPostCodeDeliverable, currentDeliverySlotId} = useBasketStore()
  const {isRapidDeliveryBooked} = useRapidDeliveryStore()

  const {isReservationExpired} = useSlotExpiration()
  const {googleMapsAPIkey} = useGlobalStore()

  const handleBookDeliveryPageRedirect = () => {
    navigate('/book-delivery', 'push', {
      redirectTo: '/basket',
    })
  }

  const buttonText = () => {
    if (isReservationExpired()) {
      if (isRapidDeliveryBooked) {
        return 'Book Rapid'
      }
      return 'Book a New Delivery Time'
    }
    return 'Change Delivery Time'
  }

  return (
    <Stack spacing="0px" align="flex-start" alignSelf="stretch" height="full">
      <Box
        borderBottom="1px"
        borderColor="gray200"
        paddingY="16px"
        width="full"
        paddingX="28px"
        display={['none', 'flex']}
        justifyContent="space-between"
      >
        <Text variant="heading1">Delivery</Text>
        {isRapidDeliveryBooked && <RapidLabelIcon width="64px" height="24px" />}
      </Box>
      <Box flexGrow="1" width="full">
        {currentDeliverySlotId ? (
          <Flex paddingLeft="24px" paddingRight="20px" width="full" gap="20px" direction="column" paddingY="20px">
            <DeliveryDateTime isBasket />
            <DeliveryAddress showMapIcon />
            <BaseButton
              variant="outlineDark"
              onClick={() => {
                handleBookDeliveryPageRedirect()
              }}
              size="sm"
              width={['full', 'auto']}
            >
              <Text
                variant="unstyled"
                fontSize="inherit"
                fontWeight="inherit"
                color={{hover: 'gray700', default: 'gray800'}}
                data-test-selector="book-delivery-time-button"
              >
                {buttonText()}
              </Text>
            </BaseButton>
          </Flex>
        ) : (
          <Box paddingX="28px" paddingY="24px">
            {!isAppliedPostCodeDeliverable ? (
              <Stack spacing="20px" align="flex-start">
                <Stack spacing="2px">
                  <Text variant="text4" color="accent0">
                    {`Sorry, we're unable to deliver ${
                      deliveryPostalCode ? 'to ' + deliveryPostalCode : ''
                    }`}
                  </Text>
                  <Text variant="text4" color="gray800" as="span">
                    Postcode not right?
                    <Text
                      variant="text4"
                      padding="0px"
                      textDecoration="underline"
                      color="accent5"
                      lineHeight="short"
                      onClick={() => {
                        handleBookDeliveryPageRedirect()
                      }}
                      cursor="pointer"
                      marginLeft="4px"
                    >
                      Change it
                    </Text>
                  </Text>
                </Stack>

                <Wrapper apiKey={googleMapsAPIkey}>
                  <NearestStoreDetails
                    storeWrapperStyles={{
                      background: '#f3f3f3',
                      padding: '15px 20px 20px',
                      marginBottom: '-10px',
                    }}
                  />
                </Wrapper>

                <BaseButton variant="outlineDark" as={Link} to="/store-finder" size="sm">
                  <Text color="gray800" variant="unstyled" fontSize="inherit" fontWeight="inherit">
                    Find a Store
                  </Text>
                </BaseButton>
              </Stack>
            ) : (
              <DeliveryInitial deliveryPostalCode={deliveryPostalCode} />
            )}
          </Box>
        )}
      </Box>
      <Box marginX="20px" marginBottom="20px" alignSelf="stretch">
        <DeliveryRestrictionNotice />
      </Box>
    </Stack>
  )
}

export const DeliveryAction = observer(DeliveryActionContainer)
